export * from './dokument-hinterlegt.interface';
